import React, { Component } from "react";
import Cookies from "universal-cookie";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
//import ShareButtonsBlogi from "../components/sharebuttons_blogi";
import { Link } from "react-router-dom";
//import Truncate from 'react-truncate-html';

import placeholderImg from "../kkc_placeholder.jpg";

import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome'
import {
  faFacebookSquare
}
  from '@fortawesome/free-brands-svg-icons'
import {
  faTwitterSquare
}
  from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

const cookies = new Cookies();
//console.log(cookies.get("lang"));

const QUERY = gql`
  query Blogi($lang: LanguageCodeFilterEnum, $cursor: String) {
    blogi(first: 3, where: { language: $lang }, after: $cursor) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          galerija {
            gallery {
              sourceUrl(size: MEDIUM_LARGE)
            }
          }
          title(format: RENDERED)
          content(format: RENDERED)
          id
          date
          slug
        }
        cursor
      }
    }
    themeGeneralSettings {
      optionsPage {
        singlePostShareButtonsText
        singlePostShareButtonsTextEn
        gimmeMore
        gimmeMoreEn
        readMore
        readMoreEn
      }
    }
  }
`;

function classList(...classes) {
  return classes.filter(item => !!item).join(" ");
}

class MatchList extends Component {
  render() {
    const {
      data: { loading, errors, blogi }
    } = this.props;





    return (
      <div id="blogs"
        data-headertitle={
          cookies.get("lang") === "LV" ? "Blogi" : cookies.get("lang") === "EN" ? "Posts" : null
        } className="mt-5 container blogs-container">
        {loading && <div className="loader" />}
        {errors && <div className="errors">...</div>}

        {!loading && !blogi && <span className="none">Nav blogu...</span>}

        {!loading &&
          blogi &&
          blogi.edges.map((match, i) => {
            let blogImage = match.node.galerija && match.node.galerija.gallery ? match.node.galerija.gallery[0].sourceUrl : placeholderImg;
            return (
            <div className="row" key={i}>
              <div
                className={classList(
                  "col-12 col-sm-6 blogs-single-card",
                  (i + 1) % 2 ? "order-1 order-sm-2" : "order-1 order-sm-1"
                )}
              >
                  <div
                    className="blogs-single-card-wrap"
                    style={{
                      backgroundImage: `url(${blogImage})`
                    }}
                  ></div>
                
              </div>
              <div
                className={classList(
                  "col-12 col-sm-6 blogs-single-card-text",
                  (i + 1) % 2 ? "order-2 order-sm-1" : "order-2 order-sm-2"
                )}
              >
                <Link
                  to={`/${cookies.get("lang").toLowerCase()}/blogi/${match.node.slug}`}
                  className="blogs-single-card-a"
                >
                  <h2>
                    {match.node.title}
                  </h2>
                </Link>
                {/* <div
                  className="blogs-single-card-text-content"
                  dangerouslySetInnerHTML={{ __html: match.node.content }}
                /> */}

                {match.node.content &&
                  <div
                    className="blogs-single-card-text-content"
                    lines={9} ellipsis={''}
                    dangerouslySetInnerHTML={{ __html: match.node.content.replace(/<img .*?>/g, "").split('</p>')[0] + '</p>' }}
                  />
                }
                <div className="blogs_bottom_wrap">
                  <Link
                    to={`/${cookies.get("lang").toLowerCase()}/blogi/${match.node.slug}`}
                    className="blogs-single-card-a-more"
                  >
                    {cookies.get("lang") === "LV" &&
                      this.props.data.themeGeneralSettings.optionsPage.readMore}
                    {cookies.get("lang") === "EN" &&
                      this.props.data.themeGeneralSettings.optionsPage.readMoreEn}
                  </Link>
                  <div className="single-share-btns">
                    <span>
                      {cookies.get("lang") === "LV" &&
                        this.props.data.themeGeneralSettings.optionsPage
                          .singlePostShareButtonsText}
                      {cookies.get("lang") === "EN" &&
                        this.props.data.themeGeneralSettings.optionsPage
                          .singlePostShareButtonsTextEn}
                    </span>
                    <span>
                      <a
                        href={'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fkanepes.lv/' + cookies.get("lang").toLowerCase() + '/blogi/' + match.node.slug + '&quote=Kaņepes%20Kultūras%20Centrs - ' + match.node.title + '&p[images][0]=' + blogImage}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Share on Facebook"
                        className="share-icon"
                        onClick={() =>
                          "window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(document.URL) + '&quote=' + encodeURIComponent(document.URL) + '&picture=' + encodeURIComponent(" + blogImage + "))); return false;"
                        }
                      >
                        <FontAwesomeIcon icon={faFacebookSquare} />
                        <span className="sr-only">Share on Facebook</span>
                      </a>
                      <a
                        href={'https://twitter.com/intent/tweet?source=https%3A%2F%2Fkanepes.lv/' + cookies.get("lang").toLowerCase() + '/blogi/' + match.node.slug + '&text=Kaņepes%20Kultūras%20Centrs - ' + match.node.title + ' https%3A%2F%2Fkanepes.lv/' + cookies.get("lang").toLowerCase() + '/blogi/' + match.node.slug + '&via=kanepeskc'}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Tweet"
                        className="share-icon"
                        onClick={() =>
                          "window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(document.title) + ':%20' + encodeURIComponent(document.URL)); return false;"
                        }
                      >
                        <FontAwesomeIcon icon={faTwitterSquare} />
                        <span className="sr-only">Tweet</span>
                      </a>
                      <a
                        href={'mailto:?subject=Kaņepes Kultūras centrs - ' + match.node.title + '&body=https%3A%2F%2Fkanepes.lv/' + cookies.get("lang").toLowerCase() + '/blogi/' + match.node.slug}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Share via E-mail"
                        className="share-icon"
                      >
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span className="sr-only">E-mail</span>
                      </a>
                    </span>
                  </div>

                </div>
              </div>
            </div>
          )})}

        {!loading && blogi && blogi.pageInfo.hasNextPage === true && (
          <div className="loadMoreWrap mb-5">
            <button onClick={this.onFetchMore}>
              {cookies.get("lang") === "LV" &&
                this.props.data.themeGeneralSettings.optionsPage.gimmeMore}
              {cookies.get("lang") === "EN" &&
                this.props.data.themeGeneralSettings.optionsPage.gimmeMoreEn}
            </button>
          </div>
        )}
      </div>
    );
  }

  onFetchMore = () => {
    const {
      data: { blogi, fetchMore }
    } = this.props;
    const cookieLang = cookies.get("lang");
    fetchMore({
      variables: {
        cursor: blogi.pageInfo.endCursor,
        lang: cookieLang
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newEdges = fetchMoreResult.blogi.edges;
        const pageInfo = fetchMoreResult.blogi.pageInfo;

        return newEdges.length
          ? {
            // Put the new blogi at the end of the list and update `pageInfo`
            // so we have the new `endCursor` and `hasNextPage` values
            blogi: {
              __typename: previousResult.blogi.__typename,
              edges: [...previousResult.blogi.edges, ...newEdges],
              pageInfo
            }
          }
          : previousResult;
      }
    });
  };
}

const cookieLang = cookies.get("lang");

export default graphql(QUERY, {
  options: {
    variables: {
      lang: cookieLang
    }
  }
})(MatchList);
